export default __webpack_public_path__ + "static/media/exercise.0e9c636c.png";